import React from "react";

const BlogSeoPanel = ({
    excerpt,
    setExcerpt,
    metaTitle,
    setMetaTitle,
    metaDescription,
    setMetaDescription,
    ogImage,
    setOgImage,
    canonicalUrl,
    setCanonicalUrl,
    publishedAt,
    setPublishedAt,
    featured,
    setFeatured,
    slug,
    setSlug,
    showSlug = false,
    className = "",
}) => {
    return (
        <div className={`add-blog-seo-panel ${className}`}>
            <h3>SEO & publishing</h3>

            {showSlug && setSlug && (
                <label>
                    <span className="add-blog-form-label">URL slug</span>
                    <input
                        type="text"
                        value={slug || ""}
                        onChange={(e) => setSlug(e.target.value)}
                        className="add-blog-form-control"
                        placeholder="my-post-slug"
                    />
                </label>
            )}

            <label>
                <span className="add-blog-form-label">Excerpt</span>
                <textarea
                    rows={2}
                    value={excerpt || ""}
                    onChange={(e) => setExcerpt(e.target.value)}
                    className="add-blog-form-control"
                    placeholder="Short summary for listings and search"
                />
            </label>

            <label>
                <span className="add-blog-form-label">Meta title</span>
                <input
                    type="text"
                    value={metaTitle || ""}
                    onChange={(e) => setMetaTitle(e.target.value)}
                    className="add-blog-form-control"
                    placeholder="SEO title (optional)"
                />
            </label>

            <label>
                <span className="add-blog-form-label">Meta description</span>
                <textarea
                    rows={2}
                    value={metaDescription || ""}
                    onChange={(e) => setMetaDescription(e.target.value)}
                    className="add-blog-form-control"
                    placeholder="155 characters for search snippets"
                />
            </label>

            <label>
                <span className="add-blog-form-label">OG image URL</span>
                <input
                    type="text"
                    value={ogImage || ""}
                    onChange={(e) => setOgImage(e.target.value)}
                    className="add-blog-form-control"
                    placeholder="Social share image (optional)"
                />
            </label>

            <label>
                <span className="add-blog-form-label">Canonical URL</span>
                <input
                    type="url"
                    value={canonicalUrl || ""}
                    onChange={(e) => setCanonicalUrl(e.target.value)}
                    className="add-blog-form-control"
                    placeholder="https://..."
                />
            </label>

            <label>
                <span className="add-blog-form-label">Publish date / schedule</span>
                <input
                    type="datetime-local"
                    value={publishedAt || ""}
                    onChange={(e) => setPublishedAt(e.target.value)}
                    className="add-blog-form-control"
                />
                <span className="add-blog-form-hint">
                    Leave empty to publish immediately when status is Live.
                </span>
            </label>

            <label className="add-blog-form-check">
                <input
                    type="checkbox"
                    checked={Boolean(featured)}
                    onChange={(e) => setFeatured(e.target.checked)}
                />
                Featured post (pin in listings)
            </label>
        </div>
    );
};

export default BlogSeoPanel;
